import { getJson, postJson, putJson } from 'utils/http';

import { OrgDashboardApiGradProgram } from './types/OrgDashboardApiGradProgram';

export function fetchGradProgram(
  orgId: string
): Promise<OrgDashboardApiGradProgram> {
  return getJson(`/data/orgdashboard/${orgId}/grad-program`).then(
    // @ts-expect-error TS(2345): Argument of type '({ gradProgram }: { gradProgram:... Remove this comment to see the full error message
    ({ gradProgram }) => gradProgram
  );
}

export function createGradProgram(
  orgId: string,
  programInfo: Record<string, any> // eslint-disable-line @typescript-eslint/no-explicit-any
): Promise<OrgDashboardApiGradProgram> {
  return postJson(`/data/orgdashboard/${orgId}/grad-program`, programInfo).then(
    // @ts-expect-error TS(2345): Argument of type '({ gradProgram }: { gradProgram:... Remove this comment to see the full error message
    ({ gradProgram }) => gradProgram
  );
}

export function updateGradProgram(
  orgId: string,
  programInfo: Record<string, any> // eslint-disable-line @typescript-eslint/no-explicit-any
): Promise<OrgDashboardApiGradProgram> {
  return putJson(`/data/orgdashboard/${orgId}/grad-program`, programInfo).then(
    // @ts-expect-error TS(2345): Argument of type '({ gradProgram }: { gradProgram:... Remove this comment to see the full error message
    ({ gradProgram }) => gradProgram
  );
}

export function hideGradProgram({ orgId }: { orgId: string }) {
  return postJson(`/data/orgdashboard/${orgId}/grad-program/hide`).then(
    // @ts-expect-error TS(2345): Argument of type '({ gradProgram }: { gradProgram:... Remove this comment to see the full error message
    ({ gradProgram }) => gradProgram
  );
}

export function unhideGradProgram({ orgId }: { orgId: string }) {
  return postJson(`/data/orgdashboard/${orgId}/grad-program/unhide`).then(
    // @ts-expect-error TS(2345): Argument of type '({ gradProgram }: { gradProgram:... Remove this comment to see the full error message
    ({ gradProgram }) => gradProgram
  );
}
